import inlineSVG from 'Vendor/inlineSvg';


import Vue from 'vue';

import VueNumber from 'vue-number-animation';
import Calculator from './components/Calculator.vue';


/* Global store */
import store from './store.js';

document.addEventListener('DOMContentLoaded', () => {
	/* Load SVGs inline, so we can colour them */
	inlineSVG.init({
		svgSelector: 'img.svg',
		initClass: 'js-inlinesvg',
	}, () => {
		document.documentElement.classList.add('is-loaded');
	});
});


/* Load plugins */
Vue.use(store);


/* Global mixins */
Vue.mixin({
	methods: {
		/* Format a float into a dollar figure */
		formatMoney(number, decimals = false) {
			const dollarPrice = number / 100;
			const formattedPrice = Number(dollarPrice).toLocaleString('en', {
				minimumFractionDigits: Number.isInteger(dollarPrice) && !decimals ? 0 : 2,
				maximumFractionDigits: 2,
			});
			return `$${formattedPrice}`;
		},

		/* Format a float into a percentage */
		formatPercent(number) {
			return `${Math.round(number * 100)}%`;
		},

		/* Format an integer with thousands separators */
		formatInteger(number) {
			return Math.round(Number(number)).toLocaleString('en', {
				minimumFractionDigits: 0,
				maximumFractionDigits: 0,
			});
		},
	},
});
Vue.use(VueNumber);


/* App */
new Vue({
	render: h => h(Calculator),
}).$mount('#app');
